import 'whatwg-fetch'

function StepsForm() {
  const actualForm = document.querySelector('.js-steps-form-form')
  const form = document.querySelector('.js-steps-form')

  if (!form) return

  const counter = [...document.querySelectorAll('.js-steps-form-counter')]
  const intros = [...document.querySelectorAll('.js-steps-form-intro')]
  const counts = [...document.querySelectorAll('.js-steps-form-count')]
  const steps = [...document.querySelectorAll('.js-steps-form-step')]
  const nextButtons = [...document.querySelectorAll('.js-steps-form-next')]
  const prevButtons = [...document.querySelectorAll('.js-steps-form-prev')]
  let index = 1

  ;[...nextButtons].forEach(button =>
    button.addEventListener('click', e => {
      counter.forEach(count => {
        count.classList.add('c-steps-form__steps-counter-inner--active')
      })
      intros.forEach(intro => {
        intro.classList.add('c-steps-form__steps-counter-intro--inactive')
      })
      const inputs = steps[index - 1].querySelectorAll('input')
      let valid = true
      ;[...inputs].forEach(input => {
        if (input.validity.valid === false && valid !== false) {
          valid = false
        }
      })
      if (valid) {
        index++
        showNewItem(counts, index, 'c-steps-form__count--active')
        showNewItem(steps, index, 'c-steps-form-step--active')
        sendStepEvent(actualForm, index, 'next')
      }
    })
  )

  counts.forEach(count => {
    count.addEventListener('click', e => {
      counter.forEach(element => {
        element.classList.add('c-steps-form__steps-counter-inner--active')
      })
      if (e.target.dataset.index > index) {
        const inputs = steps[index - 1].querySelectorAll('input')
        let valid = true
        ;[...inputs].forEach(input => {
          if (input.validity.valid === false && valid !== false) {
            valid = false
          }
        })
        if (valid) {
          index = Number(e.target.dataset.index)
          showNewItem(counts, index, 'c-steps-form__count--active')
          showNewItem(steps, index, 'c-steps-form-step--active')
          sendStepEvent(actualForm, index, 'next')
        }
      } else if (e.target.dataset.index != index) {
        index = Number(e.target.dataset.index)
        showNewItem(counts, index, 'c-steps-form__count--active')
        showNewItem(steps, index, 'c-steps-form-step--active')
        sendStepEvent(actualForm, index, 'prev')
      }
    })
  })
  ;[...prevButtons].forEach(button =>
    button.addEventListener('click', e => {
      index--
      showNewItem(counts, index, 'c-steps-form__count--active')
      showNewItem(steps, index, 'c-steps-form-step--active')
      sendStepEvent(actualForm, index, 'prev')
    })
  )

  const sendStepEvent = (form, index, direction) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'nextStep',
      form:
        form.querySelector("input[name='form_title']") !== undefined ||
        form.querySelector("input[name='form_title']") !== null
          ? form.querySelector("input[name='form_title']").value
          : 'Onbekend',
      step: index,
      direction: direction
    })
  }

  function showNewItem(items, index, className) {
    ;[...items].forEach(item => {
      if (index === parseInt(item.dataset.index)) {
        item.classList.add(className)
      } else {
        item.classList.remove(className)
      }
    })
  }

  const resetForm = form => {
    form.reset()
  }
}

export default StepsForm



// WEBPACK FOOTER //
// ./src/js/modules/StepsForm.js